// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import { withRouter } from 'react-router-dom';

import Document from '../MyStacks/Document';
import PublicDocument from '../Public/Document';
import Spreadsheet from './Spreadsheet';
import api
 from '../../api';
import '../../styles/document.css';

class FileViewer extends React.Component {
    componentDidMount = () => {
        this.loadMeta(this.props.match.params.documentId);
    }

    componentWillReceiveProps = (next) => {
        if (next.match.params.documentId !== this.props.match.params.documentId)
            this.loadMeta(next.match.params.documentId);
    }

    loadMeta = async (documentId) => {
        // If public, ignore
        if (window.location.href.includes('/public/')) return;

        const changes = {};

        // Load document jobs
        const res = await api.get('/job/getByDocument?docId=' + documentId);
        if (res && res.jobs) {
            changes.jobs = [ ...res.jobs ];

            // Paralellize the rest... 
            (async () => {
                for(const job of changes.jobs){
                    if(!job.working) continue; 

                    // Load job progress
                    const res2 = await api.get('/job/getByDocument?docId=' + documentId);
                    if (!res2 || !res2.jobs) return;

                    this.props.updateDocument({ jobs: res2.jobs }, false);
                }
            })();
        }

        const res3 = await api.get('/document/duplicates?docId=' + documentId, {}, true);
        if (res3 && res3.docs)
            changes.duplicates = [ ...res3.docs ];

        const res4 = await api.get('/document/splits?docId=' + documentId);
        if (res4 && res4.docs)
            changes.splits = [ ...res4.docs ];   

        // Still working on the same document?
        if (documentId !== this.props.document._id) return;

        this.props.setDocument({
            ...this.props.document,
            ...changes
        });
    }

    render = () => {
        const format = this.props.format ? this.props.format : "doc";
        
        // Spreadsheet viewer
        if (["xls", "xlsx", "ods", "csv"].includes(format))
            return <Spreadsheet {...this.props} />; // TODO

        // DEFAULT: Document viewer
        // Public?
        return this.props.public ? <PublicDocument {...this.props} /> : <Document {...this.props} />;
    }
};

export default withRouter(FileViewer);